// @ts-nocheck
import { CommentsState, CommentsActions, CommentsAction } from '../../types/comments';

const initialState: CommentsState = {
  comments: null,
  loading: false,
  error: null,
};

export const commentsReducer = (state = initialState, action: CommentsAction): CommentsState => {
  switch (action.type) {
    case CommentsActions.GET_COMMENTS:
      return { ...state, loading: true, error: null, comments: null };
    case CommentsActions.GET_COMMENTS_SUCCESS:
      return { ...state, loading: false, error: null, comments: action.payload };
    case CommentsActions.GET_COMMENTS_ERROR:
      return { ...state, loading: false, error: action.payload, comments: null };

    case CommentsActions.ADD_COMMENT:
    case CommentsActions.EDIT_COMMENT:
    case CommentsActions.DELETE_COMMENTS:
      return { ...state, loading: true, error: null, comments: null };
    case CommentsActions.ADD_COMMENT_SUCCESS:
    case CommentsActions.EDIT_COMMENT_SUCCESS:
    case CommentsActions.DELETE_COMMENTS_SUCCESS:
      return { ...state, loading: false, error: null, comments: null };
    case CommentsActions.ADD_COMMENT_ERROR:
    case CommentsActions.EDIT_COMMENT_ERROR:
    case CommentsActions.DELETE_COMMENTS_ERROR:
      return { ...state, loading: false, error: action.payload, comments: null };

    default:
      return state;
  }
};
